// extracted by mini-css-extract-plugin
export default {"resetPasswordCard":"luQ5zTy9SFNnONAWI3gX"};